var angular = require('angular');

var app = angular.module('amt_admin.user_manager', []);

require('./resources/user_manager.js').default(app);

export default app.name;
